import React, { useEffect } from 'react';
import { FetchOrderHistory, ResetOrderHistory } from '../../../../actions/Dashboard';
import { useDispatch, useSelector } from 'react-redux';
import DashboardOrdersHistory from '../../../DashboardOrdersHistory/DashboardOrdersHistory';
import { getLocalSessionData, getUserSessionData } from '../../../../utils/Authentication/handleUserSession';
import { ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS } from '../../../../constants/AppConstants';
import { SOURCE_MY_DEVICE } from '../../../../pages/MyDevices/components/SuppliesComponent';

const EcoproOrderHistory = ({ source }) => {
    const dispatch = useDispatch()
    const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const OrdersHistory = useSelector(state => state.DashboardOrderHistory);

    useEffect(() => {
        dispatch(ResetOrderHistory());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (source === SOURCE_MY_DEVICE) {
            dispatch(FetchOrderHistory(UID, deviceId));
        } else {
            dispatch(FetchOrderHistory(UID, null));
        }
    }, [dispatch, UID, source, deviceId])

    return (
        <div className='height-100'>
            <DashboardOrdersHistory
                orderHistoryResult={OrdersHistory}
                orderHistory={OrdersHistory.orderHistory}
                isDashboardHomepage={true}
                cname={'active-dashboard-blocks'}
            ></DashboardOrdersHistory>
        </div>
    );
};

export default EcoproOrderHistory;